import { createSlice } from '@reduxjs/toolkit';
import { EPageType } from 'shared/common/types/pageType';

const initialState: EPageType = EPageType.M03y26smb;

/* istanbul ignore next */
const pageTypeSlice = createSlice<EPageType, {}, 'pageType'>({
  initialState,
  name: 'pageType',
  reducers: {},
});

export const { reducer: pageTypeReducer } = pageTypeSlice;
